import { ROUTE_ATTENDANCE_ITEM } from '@/router/constants'
import events from '@/libs/events'

const router = document.router
const root = { root: true }
const answerVoiceOffer = 'answer-attendance-offer'
const answerTextOffer = 'answer-attendance-offer-text'
const ipcRenderer = window.ipcRenderer

let ipcRegistered = false

const registerIPC = ({ dispatch }) => {
  if (ipcRegistered) return

  const busEvents = events()

  const onAnswerVoiceOffer = (attendance) => {
    const { accepted, id: attendanceId } = attendance
    if (!accepted) return dispatch('sipModule/cancel', attendanceId, root)
    dispatch('sipModule/accept', attendanceId, root)
    router.push({ name: ROUTE_ATTENDANCE_ITEM, params: { attendanceId } }).catch(() => {})
  }

  const onAnswerTextOffer = (attendance) => {
    const { accepted, id: attendanceId, channel } = attendance
    if (!accepted) return dispatch('socketModule/rejectAttendance', { id: attendanceId, channel }, root)
    dispatch('socketModule/acceptAttendance', { id: attendanceId, channel }, root)
    router.push({ name: ROUTE_ATTENDANCE_ITEM, params: { attendanceId } }).catch(() => {})
  }

  busEvents.on(answerTextOffer, onAnswerTextOffer)
  busEvents.on(answerVoiceOffer, onAnswerVoiceOffer)

  ipcRenderer.on(answerTextOffer, (_, attendance) => onAnswerTextOffer(attendance))
  ipcRenderer.on(answerVoiceOffer, (_, attendance) => onAnswerVoiceOffer(attendance))

  ipcRegistered = true
}

const actions = {
  register (ctx) {
    registerIPC(ctx)
  }
}

export default {
  namespaced: true,
  actions
}
